import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root",
})
export class CryptoService{
    async decrypt(cipherTextBase64:string,base64IV:string, AES_Key:string): Promise<string>{
        const keyBytes = Uint8Array.from(atob(AES_Key), c => c.charCodeAt(0));
        const ivBytes = Uint8Array.from(atob(base64IV), c => c.charCodeAt(0));
        const cipherTextBytes = Uint8Array.from(atob(cipherTextBase64), c => c.charCodeAt(0));
        const cryptoKey = await crypto.subtle.importKey(
            "raw",
            keyBytes,
            { name: "AES-CBC" },
            false,
            ["decrypt"]
        );
        const decryptedBuffer = await crypto.subtle.decrypt(
            { name: "AES-CBC", iv: ivBytes },
            cryptoKey,
            cipherTextBytes
        );
        return new TextDecoder().decode(decryptedBuffer);
    }
}